// DEV
export const environment = {
  production: false, 
  hideConsoleLog: true,
  // Was "https://legacy.forensicnotes.com555". `.com555` is not a valid TLD, so
  // that value could never have resolved. Corrected to the host the other ten
  // environment files use. NOT verified as live: DNS is unavailable from the
  // machine this was fixed on, so this makes the value consistent and
  // syntactically valid, and does not assert that the legacy app is up.
  AdvanceMode : "https://legacy.forensicnotes.com",

  LoginUrl: "https://osintfn.b2clogin.com/osintfn.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_UserSignIn&client_id=2b68b226-6cf7-4ed7-b89c-61655458865b",
  // LoginUrl: "https://osintfn.b2clogin.com/osintfn.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_UserSignIn&client_id=92d1949b-1841-4498-b118-fd931dc5f5ca",

  FAQ: 'https://www.forensicnotes.com/faqs',
  RequireAuthentication: true,      // Change to false if local and AUTH not required.
  ChunkSize: 1048576,
  notebookPageSize: 5, //,

  // App Insights: DEV component appi-fnotes-api-dev (rg-fnotes-dev). Never the
  // production fnapi component; dev telemetry must not reach prod (plan A3).
  insightsInstrumentationKey: '183a3d59-1c2c-4af1-b353-b4acb1b9a542',
  // auth-config settings...
  clientID: '2b68b226-6cf7-4ed7-b89c-61655458865b',       // NOTE - Make sure ID matches ID in LoginURL above
  // clientID: '92d1949b-1841-4498-b118-fd931dc5f5ca',       // NOTE - Make sure ID matches ID in LoginURL above

  authorityDomain: 'osintfn.b2clogin.com',
  signUpSignIn: 'B2C_1_UserSignIn',
  editProfile: 'B2C_1_edit_profile',

  authorityLogin: 'https://osintfn.b2clogin.com/osintfn.onmicrosoft.com/B2C_1_UserSignIn',
  authorityEdit: 'https://osintfn.b2clogin.com/osintfn.onmicrosoft.com/B2C_1_edit_profile',
  
  
  postLogoutRedirectUri: "https://www.forensicnotes.com",
  // API's
  //
  // DEV = rg-fnotes-dev. The frontend half of this pair is the static web app
  // fnotes-web-dev, which serves dev.forensicnotes.com; fnotes-api-dev is its API.
  // This used to point at staging-forensicnotes-api (RG "DEVELOPMENT"), which is
  // the OLDER environment behind staging-app.forensicnotes.com.
  //
  // The REST endpoint and the SignalR endpoint below MUST stay on the same host.
  // The hub only broadcasts about notes its own API wrote, so splitting them
  // across the two environments produces a connection that works and then never
  // reports anything - which is far harder to diagnose than an outright failure.
  //
  // Auth is unaffected by the move: both APIs are configured against the same B2C
  // app registration (ClientId 92d1949b-..., osintfn.onmicrosoft.com,
  // B2C_1_UserSignIn), which is the same one `scopes` below targets.
  apiBaseUrlEndpoint: 'https://fnotes-api-dev.azurewebsites.net',
  // CRM API. The previous comment here claimed the CRM/CMS suite was retired in
  // 1b02056 and that these hosts were "dead but unused (calls removed)". Only the
  // first half was true. 1b02056 removed the two loadCMSSettings() init calls and
  // hid the nav; it did NOT remove the CRM calls that the Entities feature makes.
  // These are still live callers of the three endpoints below:
  //   person-entity-v2.component.ts -> caseManagementService.AddUpdatePerson()
  //                                    (PUT /api/Person/{Witness|Suspect|...})
  //   case-management.service.ts    -> GET /api/Person/ByNote/{noteId}, which is
  //                                    what fills the notebook Entities section
  //   asset-management.service.ts   -> /api/Vendor, /api/Software, /api/LicenseGroup
  // Pointing them at the dead mangoforest host is why adding an entity wrote the
  // note but never created its CaseManagement link row, so Entities stayed empty.
  //
  // crm-api-dev-2.mangoforest-769e62fe is NXDOMAIN - the whole mangoforest Container
  // Apps environment is gone. The live DEV CRM is crmapi-dev (RG osint-shared-dev-rg,
  // env cae-osint-dev), reached by its custom domain below rather than its
  // gentlemushroom FQDN so an environment rebuild does not break this again.
  //
  // Verified against the running app before this was changed: it serves the Person,
  // Admin, Client, ClientContact, InternalContact, DepartmentalUnit, Vendor, Software
  // and LicenseGroup routes; it allows origins http://localhost:4200 and
  // https://dev.forensicnotes.com; it validates this same B2C token (audience
  // 92d1949b-..., the `scopes` value below); and it reads the SAME database as
  // apiBaseUrlEndpoint above - fndev.database.windows.net / ForensicNotesCore - so
  // the link rows land where the Notes API will read them.
  assetsApiEndPoint: 'https://crmapi-dev.forensicnotes.com',
  caseManagementApiEndpoint: 'https://crmapi-dev.forensicnotes.com',
  organizationApiEndpoint: 'https://crmapi-dev.forensicnotes.com',
  // WebSocket - SignalR - Does not work via Front Door.
  //
  // This is the API host, NOT dev.forensicnotes.com. That domain is the Angular
  // app itself (static web app fnotes-web-dev) - POSTing a negotiate to it returns
  // 405, because static hosting only answers GET/HEAD. The hub lives on the API.
  //
  // Must match apiBaseUrlEndpoint above. See the note there.
  apiSignalRSocketApiEndPoint: 'https://fnotes-api-dev.azurewebsites.net',
  // Scope - Copied from the 'Expose an API' section for the Notes API App Registration
  scopes: 'https://osintfn.onmicrosoft.com/92d1949b-1841-4498-b118-fd931dc5f5ca/access_as_user',
};
